import script from "./insurance-list.vue?vue&type=script&lang=ts&setup=true"
export * from "./insurance-list.vue?vue&type=script&lang=ts&setup=true"

import "./insurance-list.vue?vue&type=style&index=0&id=d3ec8a1c&scoped=true&lang=scss"
import "./insurance-list.vue?vue&type=style&index=1&id=d3ec8a1c&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3ec8a1c"]])

export default __exports__